import React, { useEffect } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Div } from "components/Base";
import { actions, getters } from "../model";
import Tabs from "./Tabs";
import { TAB_IDS } from "../constants";
import Details from "./Details";
import Participants from "./Participants/View";
import Tasks from "./Tasks";
import {
  getBackgroundColor,
  getAccentColor
} from "Portal/NewPortal/PortalHome/selectors";
// import Files from "./Files/View";
import Files from "EventLight/Sessions/SessionContent/View";
import Subsessions from "./Subsessions/Subsessions";

const decorate = connect(
  state => ({
    selectedTab: getters.selectedTab(state),
    fromHomePage: getters.fromHomePage(state),
    backgroundColor: getBackgroundColor(state),
    sessionData: getters.sessionData(state),
    contactDataInUse: getters.contactDataInUse(state),
    accentColor: getAccentColor(state)
  }),
  {
    init: actions.init
  }
);

const Body = ({
  fromHomePage = false,
  selectedTab = TAB_IDS.DETAILS,
  backgroundColor = null,
  sessionData,
  contactDataInUse = {},
  accentColor
}) => {
  useEffect(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth > 1200 && !fromHomePage) {
      document.body.style.overflow = "";
    }
  }, []);

  const Content = R.prop(selectedTab)({
    [TAB_IDS.DETAILS]: Details,
    [TAB_IDS.FILE_CONTENT]: Files,
    [TAB_IDS.TASKS]: Tasks,
    [TAB_IDS.PARTICIPANTS]: Participants,
    [TAB_IDS.SUBSESSIONS]: Subsessions
  });

  return (
    <Div
      display="column.flex-start.flex-start"
      width={1}
      height={1}
      style={{
        padding: !R.isEmpty(contactDataInUse) ? "0" : "3px 20px 20px 20px",
        gap: "16px",
        ...(backgroundColor ? { backgroundColor } : {})
      }}
    >
      <Tabs />
      <Content
        {...{
          accentColor,
          viaPortal: true,
          sessionId: sessionData ? sessionData.id : null
        }}
      />
    </Div>
  );
};

export default decorate(Body);
